import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function UrgencyBlock() {
  return <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{
    once: true
  }} className="text-center bg-[#111111] border border-[#FF3B3B]/30 rounded-2xl max-sm:rounded-xl p-8 max-sm:p-5 md:p-12 shadow-[0_0_30px_rgba(255,59,59,0.05)]" data-id="element-123">
      <div className="flex justify-center mb-6" data-id="element-124">
        <ClockIcon className="w-12 h-12 max-sm:w-9 max-sm:h-9 text-[#FF3B3B] animate-pulse" data-id="element-125" />
      </div>
      <h2 className="text-3xl max-sm:text-xl font-serif font-bold text-[#FF3B3B] mb-6 max-sm:mb-4 uppercase tracking-wide" data-id="element-126">
        ⚠️ ATENCIÓN: Esta oferta no es permanente.
      </h2>
      <p className="text-lg md:text-xl text-[#E8E0D0] mb-6" data-id="element-127">
        El precio de $12.97 está disponible por tiempo limitado como parte del
        lanzamiento de AI Generation.
      </p>
      <p className="text-lg text-[#A09880] mb-8" data-id="element-128">
        Una vez que este período termine:
        <br data-id="element-129" />
        <span className="text-[#FF3B3B] font-bold text-xl block mt-2" data-id="element-130">
          🔴 El precio sube a $97 sin los bonos
        </span>
      </p>
      <p className="text-md text-[#A09880]/70 italic mb-8" data-id="element-131">
        No hay cuenta regresiva falsa aquí.
        <br data-id="element-132" />
        Cuando el período de lanzamiento termine, el precio volverá al precio
        original.
      </p>
      <p className="text-xl md:text-2xl font-serif font-bold text-[#E8E0D0] leading-relaxed" data-id="element-133">
        La pregunta no es si puedes permitirte $12.97.
        <br data-id="element-134" />
        <span className="text-[#D4AF37] italic" data-id="element-135">
          La pregunta es si puedes permitirte seguir perdiendo tiempo sin los
          prompts correctos. 🕯️
        </span>
      </p>
    </motion.div>;
}